import { AppContext } from '../app-context.js'
import { AppTrpcServiceInjectionToken } from '../services/app-trpc.service.js'
import { AuditTrailEntry } from '@lg/shared'

export async function getAuditTrailEntriesForEntityInstance(
	entityInstance: any,
): Promise<AuditTrailEntry[]> {
	if (!entityInstance?.id) return []
	const trpc = AppContext.injector.get(AppTrpcServiceInjectionToken)
	const result =
		await trpc.client.audit.getAuditTrailEntriesForEntityInstance.query({
			__type: entityInstance.__type,
			id: entityInstance.id,
		})
	return result
}

export async function addAuditTrailMessageForEntityInstance(
	entityInstance: any,
	message: string,
) {
	const trpc = AppContext.injector.get(AppTrpcServiceInjectionToken)
	const result =
		await trpc.client.audit.addAuditTrailMessageForEntityInstance.mutate({
			entityInstance: {
				__type: entityInstance.__type,
				id: entityInstance.id,
			},
			message,
		})
	return result
}
